import * as systemUtils from "../../../abstract/controller/utils/systemUtils";
import { useYamlImport } from "../../../abstract/hook/useYamlImport";
import { ButtonDefault } from "../../ui/buttons/ButtonDefault";
import styles from "./AsideElementLearn.module.scss";
import AsideElementLearnMessage from "./AsideElementLearnMessage";

function AsideElementLearn({ handleSetTutorialInteractive, handleSetTutorialSplash, tutorialMessage, tutorial }) {
  const { loadPredefinedModel } = useYamlImport();

  const handleReset = () => {
    loadPredefinedModel("initial");

    systemUtils.clearSessionStorage();
    systemUtils.dispatchEvent("clearStorage");
  };

  return (
    <div className={styles["options"]}>
      <ButtonDefault text={"start fresh"} handler={handleReset} shadow={false} wide />
      <ButtonDefault handler={handleSetTutorialInteractive} text="interactive tutorials" shadow={false} wide />
      <ButtonDefault
        handler={handleSetTutorialSplash}
        text="restart tutorial - Splash"
        shadow={false}
        wide
      />
      <AsideElementLearnMessage tutorial={tutorial} message={tutorialMessage}/>
    </div>
  );
}

export default AsideElementLearn;
